import dayjs from "dayjs";
import Enumerable from "linq";
export class TopInformationViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.nonresponseInformation = Enumerable.from(data.nonresponseInformation).select(x => new InformationViewModel(x)).toArray();
        this.latestInformation = Enumerable.from(data.latestInformation).select(x => new InformationViewModel(x)).toArray();
    }
    model = null;
    nonresponseInformation = [];
    latestInformation = [];
}
export class InformationViewModel {
    constructor(model) {
        this.model = model;
    }
    model;
    oneWeekLaterDate = dayjs().add(1, "week").startOf("date");
    get informationNo() {
        return this.model.informationNo;
    }
    get weight() {
        return this.model.weight;
    }
    get startAt() {
        return this.model.startAt;
    }
    get isResponseRequired() {
        return this.model.isResponseRequired;
    }
    get subject() {
        return this.model.subject;
    }
    get responseDeadline() {
        return this.model.responseDeadline;
    }
    get deadlineApproaching() {
        return dayjs(this.model.responseDeadline).startOf("date").isBefore(this.oneWeekLaterDate);
    }
}
